import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './style'
import arkLogoFull from '../../layouts/ark-logo-full.svg'

const ArkLogo = ({ fallbackText = 'The Ark' }) => {
  const classes = useStyles()
  const [imageError, setImageError] = useState(false)

  const handleImageError = () => {
    setImageError(true)
  }

  if (imageError) {
    return (
      <Typography variant='h6' className={classes.fallbackText}>
        {fallbackText}
      </Typography>
    )
  }

  return (
    <img
      src={arkLogoFull}
      alt='The Ark'
      className={classes.logo}
      onError={handleImageError}
    />
  )
}

export default ArkLogo
